module.exports = __webpack_public_path__ + "static/2d-f82f7a49fb607fe2b2fc2e17e1d4e58e.png";